// extracted by mini-css-extract-plugin
module.exports =  {"odd":"_7506d987b5--odd--XOcPK","even":"_7506d987b5--even--y5gKZ"};